import React, { useRef } from 'react';
import { IVideo } from '../../../../utils/types/contentful';
import './video.css';

export const Video = ({ width, height, url, preload = 'auto' }: IVideo) => {
  const vidRef = useRef(null);

  return (
    <div
      className='relative overflow-hidden w-full h-full'
      style={{ height, width }}>
      <video
        className='video absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
        ref={vidRef}
        disableremoteplayback=''
        height='100%'
        preload={preload}
        autoPlay
        loop
        muted
        playsinline=''
        width='100%'>
        <source
          src={url.file.url}
          type={url.file.contentType}
        />
      </video>
    </div>
  );
};
